import { render, staticRenderFns } from "./SampleReport.vue?vue&type=template&id=0ed82292&scoped=true&"
import script from "./SampleReport.vue?vue&type=script&lang=ts&"
export * from "./SampleReport.vue?vue&type=script&lang=ts&"
import style0 from "./SampleReport.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SampleReport.vue?vue&type=style&index=1&id=0ed82292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed82292",
  null
  
)

export default component.exports